module.exports = __webpack_public_path__ + "static/media/404-img.dbd2db2f.svg";